import { connectSearchBox } from 'instantsearch.js/es/connectors';

const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query,refine, clear,isSearchStalled,widgetParams } = renderOptions;
    let rechercheUrl = $('#rechercheHeader').data('recherche-url');
    let valeurRecherche = $('#rechercheHeader').data('valeur-recherche');
    let valeurChargement = $('#rechercheHeader').data('valeur-chargement');
    let searchPlaceholder = $('#rechercheHeader').data('search-placeholder');
    if (isFirstRender) {

        // Création d'une div
        // const divContainer = document.createElement('div');
        // divContainer.className = "container";// ajout des classes

        // Création de formulaire
        const form = document.createElement('form');
        form.className = " barreRecherche-interne"; // ajout des classes
        form.action = rechercheUrl; // ajout de l'url d'action
        form.method = "post"; // ajout de ma methode
       
        // Création d'une div
        const divForm = document.createElement('div');
        divForm.className = "headerSite-recherche-input form-group";

        // Création de l'input
        const input = document.createElement('input');
        input.type = "text";// ajout des classes
        input.className = "form-control form-control-lg";// ajout des classes
        input.name = "recherche";// ajout d'un nom
        input.id = "recherche-header";// ajout d'un nom
        input.placeholder = searchPlaceholder; // ajout du placeholder
        input.autocomplete = "off";
        // si valeur de recherche existe
        if(valeurRecherche){
            input.value = valeurRecherche; // definie la valeur
            refine(input.value); // on charge la valeur
        }
        
        // Création span de chargement
        const loadingIndicator = document.createElement('span');
        loadingIndicator.textContent = valeurChargement;
        

        input.addEventListener('input', event => {
          refine(event.target.value);
        });
    
        // mise en forme des div et du formulaire
        widgetParams.container.appendChild(form);
        form.append(divForm);
        divForm.append(input);
        divForm.append(loadingIndicator);
      }
      widgetParams.container.querySelector('span').hidden = !isSearchStalled;
}

const customSearchBoxHeader = connectSearchBox(renderSearchBox);
export default customSearchBoxHeader;


